export async function POST({ request }) {
	const res = await fetch('https://users.roblox.com/v1/users', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: await request.text()
	});

	return new Response(await res.text(), {
		status: res.status,
		headers: { 'Content-Type': 'application/json' }
	});
}
